import { render, staticRenderFns } from "./CountStatusesSettings.vue?vue&type=template&id=077880de&scoped=true&"
import script from "./CountStatusesSettings.vue?vue&type=script&lang=js&"
export * from "./CountStatusesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077880de",
  null
  
)

export default component.exports